import React from 'react';
import twMerge from 'utilities/src/twMerge';
import Image from '../../Image';
import PurifiedText from '../../PurifiedText';
import { NewMenuItemExtraContent } from '../../../data/MenuItem';

interface ExtraContentProps {
  extraContent: NewMenuItemExtraContent;
}

export default function ExtraContent({ extraContent }: ExtraContentProps) {
  return (
    <div
      className={twMerge(
        'bg-site-neutrals-25 mx-8 mt-auto flex gap-4 rounded-lg p-4 shadow-md',
        'mdS:hidden',
        'mdL:flex mdL:bg-transparent mdL:border-t-site-neutrals-100 mdL:mx-0 mdL:shadow-none mdL:rounded-none mdL:p-0 mdL:pt-6 mdL:border-t',
        extraContent.image.data ? '' : 'flex-col',
      )}
    >
      {extraContent.client.data && (
        <Image
          src={extraContent.client.data.attributes.client_logos.color_logo.data.attributes.url}
          alt={extraContent.client.data.attributes.client_name}
          width={120}
          height={120}
          className="h-11 w-28 object-cover"
        />
      )}

      {extraContent.image.data && (
        <Image
          src={extraContent.image.data.attributes.url}
          alt={extraContent.image.data.attributes.alternativeText || ''}
          width={100}
          height={100}
          className="h-16 w-16 rounded object-cover"
        />
      )}
      <PurifiedText className="text-site-neutrals-900 site-paragraph-s [&_a]:underline">
        {extraContent.content}
      </PurifiedText>
    </div>
  );
}
